import { actualsVsPlanBreakdownSchema } from '@tempo-io/reporting-store-dto';
import {
  INSIGHTS_TIMEOUT_MS,
  REPORTING_STORE_API_BASE,
} from '@/common/api/reporting-store/constants';
import { tempoApi } from '@/common/api/tempoApi';
import type { ParsedInsightsFilters } from '@/common/api/types/dashboard/filters';
import type { VarianceGroupBy } from '@/common/api/types/dashboard/variance';
import { buildInsightsApiFilter } from '@/features/insights-dashboard/utils/buildInsightsApiFilter';

const getVarianceBreakdown = async ({
  filters,
  scopeItemId,
  loopId,
  groupBy,
}: {
  filters: ParsedInsightsFilters;
  scopeItemId?: number;
  loopId: number;
  groupBy: VarianceGroupBy[];
}) => {
  const filterString = buildInsightsApiFilter(filters, scopeItemId, loopId);

  const searchParams = new URLSearchParams();
  for (const value of groupBy) {
    searchParams.append('groupBy', value);
  }
  if (filterString) {
    searchParams.set('filter', filterString);
  }

  const response = await tempoApi()
    .get(`${REPORTING_STORE_API_BASE}/variance`, {
      searchParams,
      timeout: INSIGHTS_TIMEOUT_MS,
    })
    .json();

  return actualsVsPlanBreakdownSchema.parse(response);
};

export const VarianceApi = {
  getVarianceBreakdown,
};
